import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default function SupportStatusLabel({ supportStatus }) {
  let statusClass;
  
  switch (supportStatus.value) {
  case 'requested':
    statusClass = 'label-import-request-requested';
    break;
  case 'in_progress':
    statusClass = 'label-import-request-in-progress';
    break;
  case 'completed':
    statusClass = 'label-import-request-completed';
    break;
  case 'failed':
    statusClass = 'label-import-request-failed';
    break;
  }

  return (
    <div className={classNames('label', 'pill-label', statusClass)}>
      {supportStatus.label}
    </div>
  );
}

SupportStatusLabel.propTypes = {
  supportStatus: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }).isRequired
};
